import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select} from "antd";
import {useModel} from "../../../models";
import moment from "moment";

const {RangePicker} = DatePicker;

const rangeConfig = {
    rules: [{type: 'array', required: false, message: '请选择制单日期!'}],
};

export default function () {
    const [form] = Form.useForm();

    const [
        {saleOrderStatusDict, invoiceTypeDict, customerDict},
    ] = useModel("cmDict");

    const [
        {searchParam, documentPageInfo},
        {setSearchParam, resetSearchParam, loadDocumentList}
    ] = useModel("saleOrder");

    useEffect(() => {
        const {startEndDate} = searchParam;
        const transDate = !!startEndDate && startEndDate.length === 2 ? [moment(startEndDate[0]), moment(startEndDate[1])] : null;
        form.setFieldsValue({
            ...searchParam,
            startEndDate: transDate
        });
    }, []);

    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, []);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const {pageSize, pageNum} = documentPageInfo;
        const {saleOrderCode, customerId, orderStatus, invoiceType} = searchParam;
        let data = {
            pageSize,
            pageNum,
            startTime,
            endTime,
            saleOrderCode,
            customerId,
            orderStatus,
            invoiceType
        }
        loadDocumentList({showMsg: true, data});
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam({});
        loadDocumentList({showMsg: true, data: {pageSize: 15, pageNum: 1}});
    }

    return (
        <Form
            form={form}
            name="sale_order_search_form"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam({...searchParam, ...e})}
        >
            <Form.Item
                name="saleOrderCode"
                label="销售订单号"
            >
                <Input placeholder="销售订单号" style={{width: "140px"}}/>
            </Form.Item>

            <Form.Item
                name="customerId"
                label="客户名称"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择客户"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={customerDict}
                    style={{width: "140px"}}
                    dropdownClassName="dark-select"
                />
            </Form.Item>
            <Form.Item
                name="orderStatus"
                label="状态"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择状态"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={saleOrderStatusDict}
                    style={{width: "140px"}}
                />
            </Form.Item>
            <Form.Item
                name="invoiceType"
                label="发票类型"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择发票类型"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={invoiceTypeDict}
                    style={{width: "140px"}}
                />
            </Form.Item>

            <Form.Item name="startEndDate" label="制单日期" {...rangeConfig}>
                <RangePicker style={{width: "220px"}}/>
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}